import plugin, { TurboMount } from "turbo-mount/vue";
import { registerComponents } from "turbo-mount/registerComponents/vite";
import i18n from "./libs/i18n";

const controllers = import.meta.glob("./**/*_controller.js", { eager: true });
const components = import.meta.glob("/components/**/*.vue", { eager: true });

const turboMount = new TurboMount({
  plugins: [i18n]
});

registerComponents({
  plugin,
  turboMount,
  components,
  controllers
});
